import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})

export class ForumsService {

  constructor(private http: HttpClient) { }

  public getResource(resourceSlug: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/forums/${resourceSlug}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }


  public getResources(): Observable<any> {
    return this.http.get(`${BASEURL}/v3/forums`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('getPlaylists', []))
      );
  }



  public getComments(resourceId: number): Observable<any> {
    return this.http.get(`${BASEURL}/v3/forums/${resourceId}/comments`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public addComment(resourceSlug: string, data: any): Observable<any> {
    return this.http.post(`${BASEURL}/v3/forums/${resourceSlug}/comments`, { comment: data }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }

  public destroyComment(resourceId: number): Observable<any> {
    return this.http.delete(`${BASEURL}/comments/${resourceId}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        catchError(this.handleError<any>('login', []))
      );
  }


  public addResource(formData:FormData): Observable<any>{
    return this.http.post(`${BASEURL}/v3/forums`, {forum: formData}, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public updateResource(resourceId: string,formData:FormData): Observable<any>{
    return this.http.put(`${BASEURL}/v3/forums/${resourceId}`, {forum: formData}, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public destroyResource(resouceId: string): Observable<any>{
    return this.http.delete(`${BASEURL}/v3/forums/${resouceId}`, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public likeResource(endpointPath: string): Observable<any>{
    return this.http.post(`${BASEURL}/${endpointPath}`, {likeable_type: 'Forum'}, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  public dislikeResource(endpointPath: string): Observable<any>{
    return this.http.delete(`${BASEURL}/${endpointPath}`, {
      headers:{'Authorization': localStorage.getItem('token')}
    })
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(error);
      return throwError(() => error);
    };
  }
}
